<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('DocumentsType')" class="mt-2">
            <documents></documents>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Documents from "./Documents.vue";

import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  components: {
    Documents
  }
};
</script>
